<div class="w-full flex flex-col items-center gap-15 mt-12">
  <h3 class="text-3xl mb-12">{{reviewingUser ? reviewingUser.firstName + "'s" : 'My'}} Goals</h3>
  <div class="w-full flex flex-col gap-20 lg:flex-row justify-around">
    <tandem-goal-card class="w-full"
                      goalType="Short-Term"
                      [goals]="shortTermGoals"
                      [currentSort]="currentShortTermSortDirection"
                      (sortGoals)="onSortGoals($event)"
                      (goalCreated)="onGoalCreated($event)"
                      (goalUpdated)="onGoalUpdated($event)"
                      (goalDeleted)="onGoalDeleted($event)"
                      [userId]="reviewingUser ? reviewingUser.uid : userId"
                      [editable]="!reviewingUser"></tandem-goal-card>
    <tandem-goal-card class="w-full"
                      goalType="Mid-Term"
                      [goals]="midTermGoals"
                      [currentSort]="currentMidTermSortDirection"
                      (sortGoals)="onSortGoals($event)"
                      (goalCreated)="onGoalCreated($event)"
                      (goalUpdated)="onGoalUpdated($event)"
                      (goalDeleted)="onGoalDeleted($event)"
                      [userId]="reviewingUser ? reviewingUser.uid : userId"
                      [editable]="!reviewingUser"></tandem-goal-card>
    <tandem-goal-card class="w-full"
                      goalType="Long-Term"
                      [goals]="longTermGoals"
                      [currentSort]="currentLongTermSortDirection"
                      (sortGoals)="onSortGoals($event)"
                      (goalCreated)="onGoalCreated($event)"
                      (goalUpdated)="onGoalUpdated($event)"
                      (goalDeleted)="onGoalDeleted($event)"
                      [userId]="reviewingUser ? reviewingUser.uid : userId"
                      [editable]="!reviewingUser"></tandem-goal-card>
  </div>
</div>
